<template>
  <NuxtLink
    :to="dragging ? undefined : universe.route"
    class="universe-item"
    draggable="false"
  >
    <div class="img-container">
      <NuxtImg
        v-if="universe.image_thumbnail ?? universe.image"
        :src="universe.image_thumbnail.url ?? universe.image.url"
        :alt="`Univers : ${universe.name}`"
        quality="80"
        width="452"
        height="452"
        format="auto"
        fit="cover"
        draggable="false"
      />
    </div>
    <div class="text-container">
      {{ capitalize(universe.name) }}
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import type { GameTypeWithRoute } from '~/types'

withDefaults(
  defineProps<{
    universe: GameTypeWithRoute
    dragging: boolean
  }>(),
  {
    dragging: false,
  },
)
</script>

<style lang="scss" scoped>
.universe-item {
  display: flex;
  flex-direction: column;
  width: 22.6rem;
  height: 29.3rem;
  color: $dark;
  text-decoration: none;

  .img-container {
    width: 100%;
    height: 22.6rem;
    background: #999;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .text-container {
    width: 100%;
    height: 6.7rem;
    padding: 0 2rem;
    font-size: 1.5rem;
    line-height: 6.7rem;
    text-align: left;
    border: 1px solid #dedede;
  }
}
</style>
